import { getProductCategories } from "@hardware/Services/CustomProductService";
import { setGA4Event } from "@hardware/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";

addToChainAfter(chain, PopulateApiParameter, async props => {
    const state = props.getState();
    const currentCart = state.data.carts.byId[props.apiParameter.cartId];

    if (!currentCart?.cartLines) {
        return;
    }

    const result = await getProductCategories({
        productIds: [...currentCart.cartLines.map(cl => cl.productId!)],
        type: "product",
    });

    if (result.successful) {
        const productProperties = result.result.productProperties;
        setGA4Event("remove_from_cart", currentCart.cartLines, {
            productProperties,
        });
    }
});
